import {
  requiredString,
  optionalString,
  optionalPhone,
  requiredEmail,
  requiredPositiveInteger,
  currencyPence,
  createResourceSchema
} from './common'

export const bookingSchema = createResourceSchema({
  guest_name: requiredString('Guest name'),
  guest_email: requiredEmail('Email'),
  guest_phone: optionalPhone,
  date: requiredString('Date'),
  time: requiredString('Time'),
  party_size: requiredPositiveInteger('Party size'),
  venue_id: optionalString,
  package_id: optionalString,
  total_pence: currencyPence('Total'),
  notes: optionalString,
  internal_notes: optionalString
})
